// import library
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
// import component
import Layout from "../../layouts/Layout";
import LoaderIcon from "../../components/Common/Icon/Loader";
// import files
import { env } from "../../env";
import moment from "moment";

const TransactionView = () => {
    // variables
    const { t } = useTranslation();
    const { documentNumber, customerId, date } = useParams();
    const [isLoader, setIsLoader] = useState(true);
    const [showTotalSummary, setShowTotalSummary] = useState(false);
    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [transactionDetail, setTransactionDetail] = useState({});
    const [comment, setComment] = useState("");
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const [finalSummary, setFinalSummary] = useState({
        "totalItem" : 0,
        "totalQuantity" : 0,
        "totalNetAmount" : 0,
        "totalVats" : 0,
        "totalAmount" : 0,
        "totalDiscount" : 0,
        "totalDiscount1" : 0,
        "transportationFee" : 0
    });


    useEffect(() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const fetchData = async () => {
            getDefaultProductImage(baseUrl, token);
            getTransactionDetailApi(baseUrl, token);
        };
        fetchData();
    }, []);

    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getTransactionDetailApi = async(url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetTransactionDetail?document_number=${documentNumber}&customer_id=${customerId}&date=${date}`,{ headers })
        .then((response) => {
            setComment(localStorage.getItem('d_comment'))
            setTransactionDetail(response.data);
            const totalQty = response.data.reduce((sum, item) => sum + Number(item.qty), 0);
            const totalPDiscount1 = response.data.reduce((sum, item) => sum + Number(item.disc1prc), 0);
            const totalPDiscount2 = response.data.reduce((sum, item) => sum + Number(item.disc2prc), 0);
            const totalPDiscount3 = response.data.reduce((sum, item) => sum + Number(item.disc3prc), 0);
            const totalDiscount = totalPDiscount1+totalPDiscount2+totalPDiscount3;
            const totalVDiscount1 = response.data.reduce((sum, item) => sum + Number(item.disc1val_line), 0);
            const totalVDiscount2 = response.data.reduce((sum, item) => sum + Number(item.disc2val_line), 0);
            const totalVDiscount3 = response.data.reduce((sum, item) => sum + Number(item.disc3val_line), 0);
            const totalDiscount1 = totalVDiscount1+totalVDiscount2+totalVDiscount3;
            const totalNet = response.data.reduce((sum, item) => sum + Number(item.netlineval), 0);
            const totalVat = response.data.reduce((sum, item) => sum + Number(item.vatamnt_line), 0);
            const totalAmount = totalNet + totalVat;

            setFinalSummary({
                ...finalSummary,
                "totalItem" : response.data.length,
                "totalQuantity" : totalQty,
                "totalNetAmount" : totalNet,
                "totalVats" : totalVat,
                "totalAmount" : totalAmount,
                "totalDiscount" : totalDiscount,
                "totalDiscount1" : totalDiscount1,
                "transportationFee" : 0
            });

            setIsLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };

    return (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="sm:text-2xl font-semibold capitalize">{ t('transaction detail') }</h1>
                        <p className="text-light-400 text-xs sm:text-sm capitalize"><NavLink to={"/customers"}>{ t('profile') }</NavLink> / <NavLink to={`/customers/detail/${customerId}`}>{ t('customer profile') }</NavLink> / { t('transaction detail') }</p>
                    </div>
                    <div className="hidden sm:flex justify-end items-center space-x-4">
                        <NavLink to={`/customers/detail/${customerId}`}>
                            <button type="button" className="text-center px-2 sm:px-4 text-sm font-medium sm:text-base py-2 text-blue-normal bg-white border border-blue-normal rounded-lg tracking-wide capitalize">{ t('close') }</button>
                        </NavLink>
                    </div>
                    <NavLink to={`/customers/detail/${customerId}`} className="sm:hidden block">
                        <div className="bg-black-100 flex items-center p-3 rounded-lg">
                            <img src="../../../../assets/icons/profile/cancel.svg" alt="cancel" />
                        </div>
                    </NavLink>
                </div>
                { isLoader
                    ?
                        <LoaderIcon />
                    :
                        <div className="space-y-2 sm:space-y-4">
                            <div className="bg-white border border-white rounded-lg p-2 lg:p-4 hidden sm:flex justify-between shadow-around">
                                <div></div>
                                <div className="space-y-2">
                                    <h1 className="capitalize font-medium text-light-400 text-xs lg:text-sm">{ t('document number')}</h1>
                                    <div className="font-bold text-sm lg:text-base">{documentNumber}</div>
                                </div>
                                <div className="border border-dashed border-black-100"></div>
                                <div className="space-y-2">
                                    <h1 className="capitalize font-medium text-light-400 text-xs lg:text-sm">{ t('total items')}</h1>
                                    <div className="font-bold text-sm lg:text-base">{finalSummary.totalItem}</div>
                                </div>
                                <div className="border border-dashed border-black-100"></div>
                                <div className="space-y-2">
                                    <h1 className="capitalize font-medium text-light-400 text-xs lg:text-sm">{ t('total quantity')}</h1>
                                    <div className="font-bold text-sm lg:text-base">{formatter.format(finalSummary.totalQuantity)}</div>
                                </div>
                                <div className="border border-dashed border-black-100"></div>
                                <div className="space-y-2">
                                    <h1 className="capitalize font-medium text-light-400 text-xs lg:text-sm">{ t('order total')}</h1>
                                    <div className="font-bold text-sm lg:text-base">{formatter.format(finalSummary.totalAmount)} €</div>
                                </div>
                                <div className="border border-dashed border-black-100"></div>
                                <div className="space-y-2">
                                    <h1 className="capitalize font-medium text-light-400 text-xs lg:text-sm">{ t('created date')}</h1>
                                    <div className="font-bold text-sm lg:text-base">{moment(date).format("DD/MM/YYYY")}</div>
                                </div>
                                <div></div>
                            </div> 
                            <div className="bg-white border border-white rounded-lg p-2 lg:p-4 block sm:hidden text-xs space-y-1 shadow-around">
                                <div className="flex justify-between">
                                    <div className="flex space-x-1">
                                        <h1 className="capitalize font-medium text-light-400">{ t('document no')}:</h1>
                                        <div className="font-medium text-light-400">{documentNumber}</div>
                                    </div>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex space-x-1">
                                        <h1 className="capitalize font-medium text-light-400">{ t('total items')}:</h1>
                                        <div className="font-medium text-light-400">{transactionDetail.length}</div>
                                    </div>
                                    <div className="flex space-x-1">
                                        <h1 className="capitalize font-medium text-light-400">{ t('total quantity')}:</h1>
                                        <div className="font-medium text-light-400">{formatter.format(finalSummary.totalQuantity)}</div>
                                    </div>
                                </div>
                                <div className="flex justify-end">
                                    <div className="flex space-x-1">
                                        <h1 className="capitalize font-medium">{ t('order total')}:</h1>
                                        <div className="font-bold">{formatter.format(finalSummary.totalAmount)} €</div>
                                    </div>
                                </div>
                                <div className="flex space-x-1 text-green-normal bg-green-light w-fit p-2 rounded-full">
                                    <h1 className="capitalize font-medium">{ t('created on')}</h1>
                                    <div className="font-bold">{moment(date).format("DD/MM/YYYY")}</div>
                                </div>
                            </div>
                            {(transactionDetail.length > 0) ?
                                <div className="space-y-4">
                                    <div className="relative overflow-x-auto sm:block hidden bg-white border border-light-100 rounded-lg shadow-around">
                                        <table className="w-full text-xs">
                                            <thead className="text-gray-normal border-b border-dashed">
                                                <tr>
                                                    <th scope="col" className="font-normal p-2 lg:p-3">
                                                        <div className="flex">
                                                            <div className="uppercase">
                                                                { t('product name')}
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="font-normal p-2 lg:p-3">
                                                        <div className="flex">
                                                            <div className="uppercase">
                                                                { t('quantity')}
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="font-normal p-2 lg:p-3">
                                                        <div className="flex">
                                                            <div className="uppercase">
                                                                { t('price')}
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="font-normal p-2 lg:p-3">
                                                        <div className="flex">
                                                            <div className="uppercase">
                                                                { t('net amount') }
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="font-normal p-2 lg:p-3">
                                                        <div className="flex">
                                                            <div className="uppercase">
                                                                { t('vat') }
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th scope="col" className="font-normal p-2 lg:p-3">
                                                        <div className="flex">
                                                            <div className="uppercase">
                                                                { t('total amount')}
                                                            </div>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(transactionDetail.length > 0) && transactionDetail.map((value, index) => (
                                                    <tr key={"transaction"+index} className={(transactionDetail.length !== index+1 ? 'border-b border-dashed' : '') + " bg-white"}>
                                                        <td className="p-2 lg:p-3 font-semibold">
                                                            <div className="flex">
                                                                <div className="w-14 sm:w-8 xl:w-auto">
                                                                    <img className="w-8 h-8" src={defaultProductImage} alt="product-img" />
                                                                </div>
                                                                <div className="ml-2 grid justify-between">
                                                                    <h1>{value.mtrl_mtrl_name}</h1>
                                                                    <p className="text-light-400 text-[10px] capitalize">{ t('product code')}: {value.mtrl_mtrl_code}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="p-2 lg:p-3 text-light-400">
                                                            {formatter.format(value.qty)}
                                                        </td>
                                                        <td className="p-2 lg:p-3 text-light-400">
                                                            {formatter.format(value.price)} €
                                                        </td>
                                                        <td className="p-2 lg:p-3 text-light-400">
                                                            {formatter.format(value.netlineval)} €
                                                        </td>
                                                        <td className="p-2 lg:p-3 text-light-400">
                                                            {formatter.format(value.vatamnt_line)} €
                                                        </td>
                                                        <td className="p-2 lg:p-3 text-light-400">
                                                            {formatter.format(value.trnlineval)} €
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="bg-white border border-white rounded-lg p-2 block sm:hidden space-y-3 shadow-around">
                                        <div className="flex justify-between items-center px-2">
                                            <h1 className="font-semibold capitalize">{ t('order details')}</h1>
                                            <div onClick={(e) => setShowTotalSummary(!showTotalSummary)} className="text-blue-normal underline font-semibold text-sm capitalize">
                                                {!showTotalSummary ? t("view price details") : t("hide price details")}
                                            </div>
                                        </div>
                                        <div className="my-2 sm:my-3 border-t border-background-normal"></div>
                                        <div className="space-y-3">
                                            {(transactionDetail.length > 0) && transactionDetail.map((value, index) => (
                                                <div key={"transaction"+index}>
                                                    <div className="flex">
                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={defaultProductImage} alt="product" />
                                                        <div className="ml-1 flex flex-col justify-between w-full space-y-1">
                                                            <div>
                                                                <div className="font-medium text-xs">{value.mtrl_mtrl_name}</div>
                                                                <div className="text-light-400 text-[10px] capitalize">{ t('product code')}: {value.mtrl_mtrl_code}</div>
                                                            </div>
                                                            <div className="flex justify-between text-[10px]">
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('initial price')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(value.price)} €</div>
                                                                </div>
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('discount in')} %:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(Number(value.disc1prc) + Number(value.disc2prc) + Number(value.disc3prc))}</div>
                                                                </div>
                                                            </div>
                                                            <div className="flex justify-between text-[10px]">
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(value.qty)}</div>
                                                                </div>
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('discount in')} €:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(Number(value.disc1val_line) + Number(value.disc2val_line) + Number(value.disc3val_line))}</div>
                                                                </div>
                                                            </div> 
                                                            <div className="flex justify-between text-[10px]">
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('free quantity')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(0)}</div>
                                                                </div>
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('amount')} :</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(value.netlineval)} €</div>
                                                                </div>
                                                            </div> 
                                                            <div className="flex justify-between text-[10px]">
                                                                <div className="flex text-light-400 items-center">
                                                                    <h1 className="capitalize font-medium">{ t('gift quantity')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(0)}</div>
                                                                </div>
                                                                <div className="flex text-light-400 items-center text-[10px]">
                                                                    <h1 className="uppercase font-medium">{ t('vat')} :</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(value.vatamnt_line)} €</div>
                                                                </div>
                                                            </div> 
                                                            <div className="flex justify-between">
                                                                <div className="flex text-light-400 items-center text-[10px]">
                                                                    <h1 className="capitalize font-medium">{ t('total quantity')}:</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(0)}</div>
                                                                </div>
                                                                <div className="flex items-center text-xs">
                                                                    <h1 className="capitalize font-medium">{ t('net value')} :</h1>
                                                                    <div className="font-bold ml-1">{formatter.format(value.netlineval)} €</div>
                                                                </div>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                    {(transactionDetail.length !== index+1) && <div className="border-t my-2 border-black-100"></div>}                                
                                                </div>
                                            ))}
                                            {showTotalSummary ?
                                                <div className="text-right space-y-3">
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                        <div className="font-bold text-sm">{formatter.format(finalSummary.totalQuantity)}</div>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total discount in')} %</div>
                                                        <div className="font-bold text-sm">{finalSummary.totalDiscount}</div>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total discount in')} €</div>
                                                        <div className="font-bold text-sm">{formatter.format(finalSummary.totalDiscount1)}</div>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total net amount')}</div>
                                                        <div className="font-bold text-sm">{formatter.format(finalSummary.totalNetAmount)} €</div>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                                        <div className="font-bold text-sm">{formatter.format(finalSummary.totalVats)} €</div>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                                        <div className="font-bold text-sm">{formatter.format(finalSummary.totalAmount)} €</div>
                                                    </div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('transportation fee')}</div>
                                                        <div className="font-bold text-sm">{formatter.format(finalSummary.transportationFee)}</div>
                                                    </div>
                                                    <div className="my-3 border-t border-background-normal"></div>
                                                    <div className="flex justify-between items-center">
                                                        <div className="font-semibold capitalize">{ t('order total')}</div>
                                                        <div className="font-bold">{formatter.format(finalSummary.totalAmount)} €</div>
                                                    </div>
                                                    
                                                </div>
                                            : null}
                                        </div>
                                    </div>
                                    <div className="grid sm:grid-cols-2 gap-2 sm:space-x-2">
                                        <div className="sm:space-y-2">
                                            <div className="py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                                <div className="px-2 sm:px-4">
                                                    <h1 className="sm:text-lg font-semibold capitalize">{ t('document comments')}</h1>
                                                </div>
                                                <div className="my-2 sm:my-3 border-t border-background-normal"></div>
                                                <div className="px-2 sm:px-4 space-y-2">
                                                    {comment ? 
                                                        <div className="text-sm">{comment}</div>
                                                        : 
                                                        <div className="font-semibold text-sm uppercase text-center">{ t('no comment available')}</div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="hidden sm:block py-2 sm:py-4 bg-white border border-white rounded-lg shadow-around">
                                            <div className="px-2 sm:px-4">
                                                <h1 className="sm:text-lg font-semibold capitalize">{ t('order summary')}</h1>
                                            </div>
                                            <div className="my-3 border-t border-background-normal"></div>
                                            <div className="px-2 sm:px-4 text-right space-y-3.5">
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                    <div className="font-bold text-sm">{formatter.format(finalSummary.totalQuantity)}</div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total discount in')} %</div>
                                                    <div className="font-bold text-sm">{finalSummary.totalDiscount}</div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total discount in')} €</div>
                                                    <div className="font-bold text-sm">{formatter.format(finalSummary.totalDiscount1)}</div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total net amount')}</div>
                                                    <div className="font-bold text-sm">{formatter.format(finalSummary.totalNetAmount)} €</div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                                    <div className="font-bold text-sm">{formatter.format(finalSummary.totalVats)} €</div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                                    <div className="font-bold text-sm">{formatter.format(finalSummary.totalAmount)} €</div>
                                                </div>
                                                <div className="flex justify-between items-center">
                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('transportation fee')}</div>
                                                    <div className="font-bold text-sm">{formatter.format(finalSummary.transportationFee)}</div>
                                                </div>
                                                <div className="my-3 border-t border-background-normal"></div>
                                                <div className="flex justify-between items-center">
                                                    <div className="font-semibold text-lg capitalize">{ t('order total')}</div>
                                                    <div className="font-bold text-lg">{formatter.format(finalSummary.totalAmount)} €</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                                <div className="bg-white border border-light-100 rounded-lg text-center uppercase py-6 font-semibold shadow-around">{ t('no records available')}</div>
                            }
                            <div className="sm:py-2"></div>
                        </div>
                }
            </div>
        </Layout>
    )
}

export default TransactionView;